module.exports = __webpack_public_path__ + "static/seo-brocoders-0a64179baf0c35762f4c012e75f9a039.png";